<div class="bar-chart-v2-wrapper">
	<div *ngIf="loading" class="bar-chart-state" aria-live="polite" aria-busy="true">
		<div class="spinner"></div>
		<div class="loader-text">Loading bar chart...</div>
	</div>

	<div *ngIf="!loading && noDataFound" class="bar-chart-state">
		No data found.
	</div>

	<div class="bar-chart-scroll-area">
		<div #barChartContainer class="bar-chart-v2-container"></div>
	</div>

	<div class="series-legend-row" *ngIf="!loading && showLegend">
		<div class="legend-item" *ngFor="let item of legendItems">
			<span class="legend-color" [style.background-color]="item.color"></span>
			<span class="legend-label">{{ item.label }}</span>
		</div>
	</div>
</div>
